import React from 'react';
import SearchBox from './SearchBox';
import PriceInfo from './PriceInfo';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withComponentId } from './../../../common/ComponentIdContext';
import { REDUCER_NAME } from '../reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../app/commonReducer';

class IndicatorsSearch extends React.Component {
  render() {
    const { condition, componentId, listOrganizationByOrganCode } = this.props;

    const {
      currentSearch: tmpCurrentSearch,
      indexData,
      dataRealtime,
    } = condition;

    const currentSearch =
      listOrganizationByOrganCode[tmpCurrentSearch.code] || tmpCurrentSearch;

    return (
      <div className="left-info-widget pr-20">
        <SearchBox currentSearch={currentSearch} id={componentId} />
        <PriceInfo indexData={dataRealtime ? dataRealtime : indexData} />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    condition: state[REDUCER_NAME].listMultiComponent[componentId].condition,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(IndicatorsSearch);
